import {Component, EventEmitter, Input, Output, OnInit, ChangeDetectorRef, AfterViewInit} from '@angular/core';
import {OperationType} from '../../model/operation-type.model';
import {DealTypeEnum} from '../../model/deal-type.enum';
import {HomeSearchFiltersAnalyticsHandler} from '../../home-search-filters-analytics-handler';
import { FilterPanel } from '../../model/filter-panel.model';
import { FilterPanelHandler } from '../../model/filter-panel-handler.model';
import { CheckboxListItem } from '../checkbox-list/model/checkbox-list-item.model';
import { ProductTypeEnum } from 'src/app/profile/models/product-type.enum';

@Component({
  selector: 'lps-operation-type-filter',
  templateUrl: './operation-type-filter.component.html',
  styleUrls: ['./operation-type-filter.component.scss']
})
export class OperationTypeFilterComponent implements OnInit, AfterViewInit {

  @Output() operationChange = new EventEmitter<DealTypeEnum>();
  @Output() productTypesChange = new EventEmitter<ProductTypeEnum[]>();
  @Input() operation: DealTypeEnum;
  @Input() panel: FilterPanel;
  @Input() productTypes: ProductTypeEnum[];
  @Input() options: CheckboxListItem[] = [
    {
      checked: false,
      value: ProductTypeEnum.RealEstateParent,
      label: 'Lançamento'
    },
    {
      checked: false,
      value: ProductTypeEnum.RealState,
      label: 'Pronto'
    }
  ];

  saleOperation: OperationType = {
    label: 'Compra',
    value: DealTypeEnum.Sale,
  };

  rentOperation: OperationType = {
    label: 'Aluguel',
    value: DealTypeEnum.Rent,
  };

  originalPanelName = '';
  panelHandler: FilterPanelHandler;

  // tslint:disable-next-line: variable-name
  private _productTypes: ProductTypeEnum[];

  constructor(
    public googleAnalyticsEventManager: HomeSearchFiltersAnalyticsHandler
  ) {}

  ngOnInit() {
    if (this.panel) {
      this.panelHandler = new FilterPanelHandler(this.panel);
      this.originalPanelName = this.panel.name;
    }

    if (this.productTypes && this.productTypes.length > 0) {
      this.options.forEach((o) => {
        o.checked = this.productTypes.some(value => value === o.value);
      });
    }
  }

  ngAfterViewInit() {
    setTimeout(() =>  this.setPanelHeader(), 0);
  }

  changeOperation(operation: DealTypeEnum) {
    let eventLabel;
    this.operation = operation;
    this.operationChange.emit(operation);

    if (operation === DealTypeEnum.Rent) {
      eventLabel = 'alugar';
      this.options.forEach((o) => {
        o.checked = false;
      });
    } else {
      const selectedOptions = this.joinSelectedProductTypes();
      eventLabel = !selectedOptions ? 'comprar' : `comprar/${selectedOptions}`;
    }

    this.googleAnalyticsEventManager.sendEvent(`tipo-transacao:${eventLabel}`);
    this.productTypes = [];
    this.setPanelHeader();
  }

  joinSelectedProductTypes() {
    return this.options
      .filter(option => option.checked)
      .map(option => option.value)
      .map(this.translateProductType)
      .join('/');
  }

  translateProductType(value) {
    return value === ProductTypeEnum.RealEstateParent ? 'lancamento' : 'pronto';
  }

  selectStage(opt: CheckboxListItem, checked: boolean) {
    opt.checked = checked;
    if (checked) {
      this.operation = DealTypeEnum.Sale;
      this.operationChange.emit(this.operation);
    }

    this.productTypes = this.options
      .filter(option => option.checked)
      .map(option => option.value);
    let eventLabel;

    if (this.operation === DealTypeEnum.Rent) {
      eventLabel = 'alugar';
      if (checked) {
        this.operation = DealTypeEnum.Sale;
        this.operationChange.emit(this.operation);
      }
    } else {
      const selectedOptions = this.joinSelectedProductTypes();
      eventLabel = !selectedOptions ? 'comprar' : `comprar/${selectedOptions}`;
    }
    this.productTypesChange.emit(this.productTypes);
    this.googleAnalyticsEventManager.sendEvent(`tipo-transacao:${eventLabel}`);
    this.setPanelHeader();
  }

  setPanelHeader() {
    if (this.panel) {
      let count = 0;
      if (this.operation) {
        count = 1;
      }
      if (this.productTypes.length) {
        count += this.productTypes.length - 1;
      }
      this.panelHandler.setPanelHeader(
        `${this.originalPanelName}${count ? ` (${count})` : ''}`
      );
    }
  }
}

